<template>
  <div>
    <!--기본정보-->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" @input="inputField"/>

<!--    사업장 개요-->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i>사업장 개요</h5>
      <div class="writeGridContainer">
        <div>
          <div>시설물명</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputA_1 }} </span>
          <ml-input v-else :readonly="true" v-model="form.inputA_1" />
        </div>
        <div>
          <div>시설종류</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputA_2 }} </span>
          <ml-input v-else :readonly="true" v-model="form.inputA_2" />
        </div>
        <div>
          <div>시설규모</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputA_3 }} </span>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputA_3" />
        </div>
        <div>
          <div>사고일시</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputA_4 }} </span>
          <date-selector v-else :readonly="board.readonly" placeholder="날짜선택" v-model="form.inputA_4" />
        </div>
        <div>
          <div>시간</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputA_5 }} </span>
          <time-selector v-else :readonly="board.readonly" placeholder="시간선택" v-model="form.inputA_5" />
          <div class="ml-1">경</div>
        </div>
        <div class="writeGridLineItem">
          <div>소재지</div>
          <span v-if="isPrint" class="print-textarea"> {{ form.inputA_6 }} </span>
          <ml-input v-else v-model="form.inputA_6" :readonly="true" />
        </div>
        <div>
          <div>사고종류</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputA_7 }} </span>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputA_7" />
        </div>
        <div>
          <div>구조물손실</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputA_8 }} </span>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputA_8" />
          <div class="ml-1">백만원</div>
        </div>
        <div>
          <div>인적피해 - 사망</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputA_9 }} </span>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputA_9" />
          <div class="ml-1">명</div>
        </div>
        <div>
          <div>인적피해 - 부상</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputA_10 }} </span>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputA_10" />
          <div class="ml-1">명</div>
        </div>
        <div>
          <div>장비손실</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputA_11 }} </span>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputA_11" />
        </div>
        <div>
          <div>중대재해처벌법
            대상여부</div>
          <span v-if="isPrint" class="print-input">{{ form.inputA_12 }}</span>
          <div v-else class="w-full flex-1 flex gap-4" style="align-self: center;">
            <vs-radio v-model="form.inputA_12" :disabled="board.readonly" vs-name="target1" vs-value="해당">해당</vs-radio>
            <vs-radio v-model="form.inputA_12" :disabled="board.readonly" vs-name="target1" vs-value="해당없음">해당없음</vs-radio>
          </div>
        </div>
      </div>
    </div>

<!--    재해자 개요-->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i>재해자 개요</h5>
      <div class="writeGridContainer">
        <div>
          <div>성명</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputB_1 }} </span>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputB_1" />
        </div>
        <div>
          <div>생년월일</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputB_2 }} </span>
          <date-selector v-else :readonly="board.readonly" placeholder="날짜선택" v-model="form.inputB_2" />
        </div>
        <div>
          <div>직업</div>
          <span v-if="isPrint" class="print-textarea"> {{ form.inputB_3 }} </span>
          <ml-input v-else v-model="form.inputB_3" :readonly="board.readonly" />
        </div>
        <div>
          <div>상해종류</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputB_4 }} </span>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputB_4" />
        </div>
        <div>
          <div>상해부위</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputB_5 }} </span>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputB_5" />
        </div>
        <div>
          <div>가해물</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputB_6 }} </span>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputB_6" />
        </div>
      </div>
      <div>※ 위 항목은 재해자별로 각각 작성하되, 동일재해로 재해자가 다수 발생된 경우 별도 서식에 추가 기재함.</div>
    </div>

    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i>재해발생 과정 및 원인</h5>
      <div>재해관련 취급설비, 작업공정의 운전 또는 상황과 당시 재해자의 행동 및 사고 발생과정 등을 기록함.</div>
      <div>- 육하원칙(언제, 누가, 어디서, 무엇을, 어떻게, 왜)에 의하여 작성함.</div>
      <h5 class="my-4" style="font-weight: 700;">1) 재해발생 과정</h5>
      <div class="writeGridContainer">
        <div class="writeGridLineItem">
          <div style="line-height: normal;">언제(재해발생일시)</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputC_1 }} </span>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputC_1" />
        </div>
        <div class="writeGridLineItem">
          <div style="line-height: normal;">어디서(지역, 공간 등 재해발생장소)</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputC_2 }} </span>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputC_2" />
        </div>
        <div class="writeGridLineItem">
          <div style="line-height: normal;">누가</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputC_3 }} </span>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputC_3" />
        </div>
        <div class="writeGridLineItem">
          <div style="line-height: normal;">무엇을 사용, 어떤환경에서(작업환경)</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputC_4 }} </span>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputC_4" />
        </div>
        <div class="writeGridLineItem">
          <div style="line-height: normal;">무엇을 하기 위하여<br/>(작업내용 및 목적)</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputC_5 }} </span>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputC_5" />
        </div>
        <div class="writeGridLineItem">
          <div style="line-height: normal;">어떻게 하다가<br/>(재해자이 동작)</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputC_6 }} </span>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputC_6" />
        </div>
        <div class="writeGridLineItem">
          <div style="line-height: normal;">어떻게 재해를 당함(발생형태)</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputC_7 }} </span>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputC_7" />
        </div>
      </div>

      <h5 class="my-4" style="font-weight: 700;">2) 재해발생원인</h5>
      <div class="writeGridContainer">
        <div class="writeGridLineItem">
          <div style="line-height: normal;">가. 인적원인</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputD_1 }} </span>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputD_1" />
        </div>
        <div class="writeGridLineItem">
          <div style="line-height: normal;">나. 물적원인</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputD_2 }} </span>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputD_2" />
        </div>
        <div class="writeGridLineItem">
          <div style="line-height: normal;">다. 관리적원인<br/>① 기술적 원인</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputD_3 }} </span>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputD_3" />
        </div>
        <div class="writeGridLineItem">
          <div style="line-height: normal;">다. 관리적원인<br/>② 교육적 원인</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputD_4 }} </span>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputD_4" />
        </div>
        <div class="writeGridLineItem">
          <div style="line-height: normal;">다. 관리적원인<br/>③ 작업관리상 원인</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputD_5 }} </span>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputD_5" />
        </div>
      </div>
    </div>

    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i>재해재발 방지 대책</h5>
      <div class="writeGridContainer">
        <div class="writeGridLineItem">
          <div style="line-height: normal;">인적원인에 대한 대책(재해원인중 인적원인이 있는 경우)</div>
          <span v-if="isPrint" class="print-textarea"> {{ form.inputE_1 }} </span>
          <ml-textarea v-else rows="5" v-model="form.inputE_1" :readonly="board.readonly" placeholder="-"/>
        </div>
        <div class="writeGridLineItem">
          <div style="line-height: normal;">물적원인에 대한 대책(재해원인중 물적원인이 있는 경우)</div>
          <span v-if="isPrint" class="print-textarea"> {{ form.inputE_2 }} </span>
          <ml-textarea v-else rows="5" v-model="form.inputE_2" :readonly="board.readonly" placeholder="-"/>
        </div>
        <div class="writeGridLineItem">
          <div style="line-height: normal;">관리적 원인에 대한 대책(재해주요원인 한가지 선택)</div>
          <span v-if="isPrint" class="print-textarea"> {{ form.inputE_3 }} </span>
          <ml-textarea v-else rows="5" v-model="form.inputE_3" :readonly="board.readonly" placeholder="- 기술적 원인에 대한 대책
- 교육적 원인에 대한 대책
- 작업관리상 원인에 대한 대책"/>
        </div>
        <div class="writeGridLineItem">
          <div style="line-height: normal;">사업장 전체에 대한 안전관리 방안</div>
          <span v-if="isPrint" class="print-textarea"> {{ form.inputE_4 }} </span>
          <ml-textarea v-else rows="5" v-model="form.inputE_4" :readonly="board.readonly" placeholder="(각기 사업장에 맞는 안전관리 방안에 대하여 기술)"/>
        </div>
      </div>
    </div>

    <file-upload-module :readonly="board.readonly" v-model="form.fileList" :is-print="isPrint" class="mt-28px" />
  </div>
</template>

<script>
import PopupPlanProject from "@/views/project/popup/PopupPlanProject";
import DateSelector from "@/components/selector/DateSelector";
import PopupProjectSetting from "@/views/project/PopupProjectSetting";
import MemberSelector from "@/components/selector/MemberSelector";
import CompanySelector from "@/components/selector/CompanySelector";
import FileUploader from "@/components/FileUploader";
import SearchNavStartEnd from "../../../../components/nav/SearchNavStartEnd.vue";
import FileUploadModule from "../../../modules/FileUploadModule.vue";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import TimeSelector from "@/components/selector/TimeSelector.vue";
import TableCustom from "@/components/TableCustom.vue";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule.vue";
import PopupLoadPrevBoard from "@/popup/PopupLoadPrevBoard.vue";

export default {
  components: {
    PopupLoadPrevBoard,
    PhotoUploadGridModule,
    TableCustom,
    TimeSelector,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
    SearchNavStartEnd,
    FileUploadModule,
    FieldSelectModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      important: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  computed: {
    projectId() {
      return parseInt(this.$route.params.proj_id);
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},

        inputA_1: "",
        inputA_2: "",
        inputA_3: "",
        inputA_4: "",
        inputA_5: "",
        inputA_6: "",
        inputA_7: "",
        inputA_8: "",
        inputA_9: "",
        inputA_10: "",
        inputA_11: "",
        inputA_12: "",

        inputB_1: "",
        inputB_2: "",
        inputB_3: "",
        inputB_4: "",
        inputB_5: "",
        inputB_6: "",

        inputC_1: "",
        inputC_2: "",
        inputC_3: "",
        inputC_4: "",
        inputC_5: "",
        inputC_6: "",
        inputC_7: "",

        inputD_1: "",
        inputD_2: "",
        inputD_3: "",
        inputD_4: "",
        inputD_5: "",

        inputE_1: "",
        inputE_2: "",
        inputE_3: "",
        inputE_4: "",

        fileList: [],
      },
    };
  },
  methods: {
    inputField(value) {
      console.log(value)
      this.form.inputA_1 = value.field_name;
      this.form.inputA_2 = value.cat1;
      this.form.inputA_6 = value.field_address;
    }
  },
};
</script>
